import { FC } from 'react';
import { Helmet } from 'react-helmet-async';
import ArticleMeta from '../../types/ArticleMeta';

interface ArticleMetaProps {
  meta: ArticleMeta;
}

const ArticleMetaComponent: FC<ArticleMetaProps> = ({ meta }) => {
  const {
    id,
    title,
    description,
    authors,
    coverImage,
    categories,
    publishDate: publishedTime,
  } = meta;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name='description' content={description ?? ''} />
      <meta property='og:type' content='article' />
      <meta
        property='og:url'
        content={`https://www.juridiikka.almainsights.fi/sisältö/${id}`}
      />
      <meta property='og:title' content={title} />
      <meta property='og:description' content={description ?? ''} />
      <meta property='og:image' content={coverImage ?? ''} />
      <meta property='og:site_name' content='Juridiikan ajankohtaiset' />
      <meta property='og:locale' content='fi_FI' />

      {authors.map((author) => (
        <meta
          key={`author-${author}`}
          property='article:author'
          content={author}
        />
      ))}

      <meta property='article:published_time' content={publishedTime} />

      <meta property='article:section' content={categories.primary} />
      {categories.secondary.map((category) => (
        <meta
          key={`category-${category}`}
          property='article:section'
          content={category}
        />
      ))}

      <link
        rel='canonical'
        href={`https://www.juridiikka.almainsights.fi/sisältö/${id}`}
      />
    </Helmet>
  );
};

export default ArticleMetaComponent;
